import { memo } from 'react';
import { Button, SpaceBetween } from '@amzn/awsui-components-core';

import { MetaDivider } from '../v2-common/MetaDivider';
import { useDownloadPdfViewModel } from './DownloadPdfViewModel';

/** "PDF" download button shown in the title metadata row for published content. */
export const DownloadPdfView = memo(function DownloadPdfView() {
  const vm = useDownloadPdfViewModel();

  if (!vm.isVisible) return null;

  return (
    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
      <MetaDivider />
      <Button
        variant="inline-link"
        iconName="download"
        loading={vm.isDownloading}
        onClick={vm.download}
      >
        PDF
      </Button>
    </SpaceBetween>
  );
});
